import { render, staticRenderFns } from "./mineGnItem.vue?vue&type=template&id=5fbd7b46&scoped=true&"
import script from "./mineGnItem.vue?vue&type=script&lang=js&"
export * from "./mineGnItem.vue?vue&type=script&lang=js&"
import style0 from "./mineGnItem.vue?vue&type=style&index=0&id=5fbd7b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd7b46",
  null
  
)

export default component.exports